import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ViberIcon} from "@hugeicons/core-free-icons";
import {Panel} from "../dashboard/components/Panel";

// Connector page that is not built yet: heading and a "Coming soon" card
const ConnectorComingSoon = ({title, icon}) => (
  <Box sx={{flex: 1, minHeight: 0, bgcolor: "#F7F7FB", overflowY: "auto"}}>
    <Stack gap={3} sx={{maxWidth: 1280, mx: "auto", width: "100%", p: {xs: 2, md: 4}, pb: "100px", boxSizing: "border-box"}}>
      <Box>
        <Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", color: "#8491F7"}}>CONNECTORS</Typography>
        <Typography component={"h1"} sx={{fontSize: 26, fontWeight: 700, color: "#23264D", letterSpacing: "-0.02em"}}>
          {title}
        </Typography>
      </Box>
      <Panel sx={{p: 6, alignItems: "center", textAlign: "center", gap: 1.5}}>
        <Box sx={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 44, height: 44, borderRadius: "14px", bgcolor: "rgba(132, 145, 247, 0.12)", color: "#4B55C9",
        }}>
          <HugeiconsIcon icon={icon} size={20}/>
        </Box>
        <Typography sx={{fontSize: 15, fontWeight: 700, color: "#23264D"}}>Coming soon</Typography>
        <Typography sx={{fontSize: 13, color: "#8A8AA0", maxWidth: 360}}>
          The {title} is on its way. You will be able to send messages to your contacts from here.
        </Typography>
      </Panel>
    </Stack>
  </Box>
);

export const RegistryViberConnectorPage = () => <ConnectorComingSoon title={"Viber Connector"} icon={ViberIcon}/>;
